import { AspectRatio } from '@natu/ui/AspectRatio';
import { DynamicDecorator } from '@natu/ui/Decorators/DynamicDecorator';
import { ResponsiveImage } from '@natu/ui/ResponsiveImage';

export const SalesMartaDecorator = () => (
  <>
    <div className="absolute bottom-0 right-0 z-[1] w-full max-w-[330px] overflow-hidden rounded-xl md:max-w-[360px] lg:-bottom-10 lg:max-w-[420px]">
      <AspectRatio ratio={1.03}>
        <ResponsiveImage
          src="https://a.storyblok.com/f/172506/1048x1020/2c42f2167f/salesmarta.webp"
          alt="sales decorator"
          fill
        />
      </AspectRatio>
    </div>
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute -bottom-[105px] -right-[135px] z-[0] size-[420px] md:-bottom-[75px] md:-right-[105px]"
    />
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-airborne absolute bottom-64 left-[15%] h-5 w-5 md:bottom-16 md:left-auto md:right-[55%] lg:right-[47%]"
    />
    <DynamicDecorator
      decorator="halfStadium"
      className="absolute right-14 top-[-18px] h-12 w-12 text-gray-100 md:right-[30%] md:top-[-50px] md:h-24 md:w-24"
    />
  </>
);
